import type { LeadTag } from "@/types/lead";
import type { MappedConversation } from "@/lib/conversation-list-map";

export const CONVERSATION_LEAD_PATCH_EVENT = "conversation-lead-patch";

export type ConversationLeadPatch = {
  leadId: string;
  assignedMemberId?: string | null;
  assignedMemberIds?: string[];
  assignedMemberLabel?: string | null;
  leadTags?: LeadTag[];
  tagIds?: string[];
  lead_stage?: string;
  lead_funnel_id?: string | null;
  stage_auto_disables_agent?: boolean;
  isUrgent?: boolean;
};

export function dispatchConversationLeadPatch(patch: ConversationLeadPatch) {
  window.dispatchEvent(
    new CustomEvent<ConversationLeadPatch>(CONVERSATION_LEAD_PATCH_EVENT, {
      detail: patch,
    }),
  );
}

export function applyConversationLeadPatch(
  conv: MappedConversation,
  patch: ConversationLeadPatch,
): MappedConversation | null {
  if (conv.lead_id !== patch.leadId) return null;

  const next: MappedConversation = { ...conv };

  if ("assignedMemberIds" in patch || "assignedMemberId" in patch) {
    if ("assignedMemberIds" in patch) {
      const ids = patch.assignedMemberIds ?? [];
      next.assigned_member_ids = ids;
      next.assigned_member_id = ids[0] ?? null;
    } else if ("assignedMemberId" in patch) {
      next.assigned_member_id = patch.assignedMemberId ?? null;
      next.assigned_member_ids = patch.assignedMemberId
        ? [patch.assignedMemberId]
        : [];
    }
    if ("assignedMemberLabel" in patch) {
      next.assignedMemberLabel = patch.assignedMemberLabel ?? null;
    }
  }

  if (patch.leadTags !== undefined) {
    next.leadTags = patch.leadTags;
    next.tagIds = patch.tagIds ?? patch.leadTags.map((tag) => tag.id);
  }

  if (patch.lead_stage !== undefined) {
    next.lead_stage = patch.lead_stage;
  }

  if (patch.lead_funnel_id !== undefined) {
    next.lead_funnel_id = patch.lead_funnel_id;
  }

  if (patch.stage_auto_disables_agent !== undefined) {
    next.stage_auto_disables_agent = patch.stage_auto_disables_agent;
  }

  if (patch.isUrgent !== undefined) {
    next.isUrgent = patch.isUrgent;
  }

  return next;
}
